var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddToCollectionMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4497 11.212L18.4488 14.7268L22.0052 14.7271V16.4847L18.4488 16.4841L18.4497 19.9998H16.6719L16.6713 16.4841L13.1163 16.4847V14.7271L16.6713 14.7268L16.6719 11.212H18.4497ZM10.0052 16.4847C10.7416 16.4847 11.3385 17.0749 11.3385 17.8029C11.3385 18.5309 10.7416 19.121 10.0052 19.121H2.00521C1.26883 19.121 0.671875 18.5309 0.671875 17.8029C0.671875 17.0749 1.26883 16.4847 2.00521 16.4847H10.0052ZM10.0052 11.212C10.7416 11.212 11.3385 11.8021 11.3385 12.5301C11.3385 13.2582 10.7416 13.8483 10.0052 13.8483H2.00521C1.26883 13.8483 0.671875 13.2582 0.671875 12.5301C0.671875 11.8021 1.26883 11.212 2.00521 11.212H10.0052ZM20.6719 5.93923C21.4083 5.93923 22.0052 6.5294 22.0052 7.25741C22.0052 7.98542 21.4083 8.5756 20.6719 8.5756H2.00521C1.26883 8.5756 0.671875 7.98542 0.671875 7.25741C0.671875 6.5294 1.26883 5.93923 2.00521 5.93923H20.6719ZM20.6719 0.666504C21.4083 0.666504 22.0052 1.25667 22.0052 1.98469C22.0052 2.7127 21.4083 3.30287 20.6719 3.30287H2.00521C1.26883 3.30287 0.671875 2.7127 0.671875 1.98469C0.671875 1.25667 1.26883 0.666504 2.00521 0.666504H20.6719Z",
    fill: "#FFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddToCollectionMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-to-collection-menu.a2bc497bc70ad6b2eb61b856782b0e81.svg";